import React, { useState, useEffect } from "react";

import { BASE_URL, EMPLOYEE_LIST } from "../../../Constants/Config";
import axios from "axios";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { Grid } from "@mui/material";
import SelectDropDown from "../../../reuseableComponents/SelectDropDown";
import CustomHeader from "../../../reuseableComponents/CustomHeader";
import SelectDropDownWithCheckBox from "../../../reuseableComponents/SelectDropDownWithCheckBox";

const SalesPersonFilter = ({
  onFilterDataChange,
  hide,
  setEmployeeList,
  employeeList,
  selectedEmployeeList,
  allOptionSelectedEmployeeList,
  handleEmployeeListOptinClick,
}) => {
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();

  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;

  const PaymentList = ["Cash & Card", "Cash", "Card"];

  const [loadingEmpList, setLoadingEmpList] = useState(true);

  useEffect(() => {
    fetchData();
  }, []); // Fetch categories only once when the component mounts
  const fetchData = async () => {
    try {
      const response = await axios.post(
        BASE_URL + EMPLOYEE_LIST,
        {
          merchant_id: merchant_id,
          token_id: userTypeData?.token_id,
          login_type: userTypeData?.login_type,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userTypeData?.token}`,
          },
        }
      );

      // Assuming the API response has a data property containing the category list
      const EmpList = response.data.result;

      // Extracting category IDs and view titles
      const mappedOptions = EmpList.map((empdata) => ({
        id: empdata.id,
        title:
          (empdata.f_name ?? "") + (empdata.l_name ? " " + empdata.l_name : ""),
      }));

      setEmployeeList(mappedOptions);
      setLoadingEmpList(false);
    } catch (error) {
      console.error("Error fetching Employee List:", error);
      setLoadingEmpList(false);
    }
  };

  return (
    <>
      <Grid container className="box_shadow_div">
        <Grid item xs={12}>
          {!hide && <CustomHeader>Detailed Sales Person Report</CustomHeader>}

          <Grid container sx={{ px: { xs: 1, sm: 2.5 }, pt: 1 }}>
            <Grid item xs={12}>
              <div className="heading">Filter By</div>
            </Grid>
          </Grid>
          <Grid container sx={{ px: { xs: 1, sm: 2.5 }, pb: 2.5 }} spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <label className="q-details-page-label" htmlFor="employeeFilter">
                Employee
              </label>
              <SelectDropDownWithCheckBox
                className="mt-1"
                options={employeeList}
                heading={"All"}
                title="title"
                label="Employee"
                onClickHandler={handleEmployeeListOptinClick}
                selectedOption={selectedEmployeeList}
                allOptionSelected={allOptionSelectedEmployeeList}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default SalesPersonFilter;
